const style = document.createElement('style');
style.id = 'sca-zindex-fix';
document.head.appendChild(style);

function updateZIndex() {
  const cartDrawer = document.querySelector('cart-drawer');
  const menuDrawer = document.querySelector('details.menu-drawer-container');
  const cartActive = cartDrawer?.classList.contains('active');
  const menuOpening = menuDrawer?.classList.contains('menu-opening');

  style.textContent = (cartActive || menuOpening)
    ? '.sca_aff_customer_refer_container { z-index: 0 !important; }'
    : '';
}

const observer = new MutationObserver(updateZIndex);

const cartDrawer = document.querySelector('cart-drawer');
const menuDrawer = document.querySelector('details.menu-drawer-container');

if (cartDrawer) observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
if (menuDrawer) observer.observe(menuDrawer, { attributes: true, attributeFilter: ['class'] });

updateZIndex();